var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('keep-alive',[(_vm.currentPage === 'listComp')?_c(_vm.currentPage,{tag:"component"}):_vm._e()],1),(_vm.currentPage === 'viewComp')?_c(_vm.currentPage,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }